/* eslint-disable no-param-reassign,no-restricted-syntax */
export default {
    setTree(state, {tree, path}) {
        state.directories = tree;
    }
};
